import { Component, Input, OnInit } from '@angular/core';
import { CaseService } from '../../../services/case.service';

interface FieldChange {
	field: string;
	oldValue: string;
	newValue: string;
}

interface HistoryEntry {
	revision: number;
	revisionDate: string;
	modifiedBy: string;
	action: 'CREATED' | 'MODIFIED' | 'DELETED' | string;
	entityLabel?: string;
	entityId?: number;
	changes: FieldChange[];
}

const FIELD_LABELS: { [key: string]: string } = {
	// Lawsuite (дело)
	caseNumber: 'Номер на дело',
	applicationNumber: 'Application номер',
	damageNumber: 'Щета номер',
	claimNumber: 'Претенция №',
	cost: 'Цена на иска',
	chastichenIsk: 'Частичен иск',
	costProperty: 'Цена (имуществен)',
	claimCost: 'Цена на претенция',
	claimCostProperty: 'Цена на претенция (имуществ.)',
	traumas: 'Травми',
	date: 'Дата на ПТП',
	mjastoPTP: 'Място на ПТП',
	claimDate: 'Дата на претенция',
	lawyer: 'Отговорник',
	claimResponsible: 'Отговорник по претенция',
	damageType: 'Тип щета',
	traumaType: 'Тип травма',
	izpulnitelnoDelo: 'Изпълнително дело',
	nakazatelnoDelo: 'Наказателно дело',
	mediator: 'Медиатор',
	percentage: 'Процент',
	vidSluchaj: 'Вид случай',
	prikljucheno: 'Приключено',
	prikljuchenReason: 'Причина за приключване',
	prikljuchenAt: 'Дата на приключване',

	// LawsuiteStatus (инстанция граждански)
	instance: 'Инстанция',
	city: 'Град',
	court: 'Съд',
	number: 'Номер на инстанция',
	dataNasrochen: 'Дата на заседание',
	timeNasrochen: 'Час на заседание',
	status: 'Статус',
	note: 'Бележка',
	lawsuiteId: 'ID на делото',
	archiveFolderName: 'Архивна папка',
	glavnica: 'Главница',
	glavnicaImushtestv: 'Главница (имуществена)',
	prietaSuma: 'Приета сума',
	raznoskiOtvetnaStrana: 'Разноски — ответна страна',
	lihvaDate: 'Лихва — дата',
	lihvaImushtestvDate: 'Лихва (имуществ.) — дата',
	prisudeniRaznoski: 'Присъдени разноски',
	suprichinjavane: 'Съпричиняване'
};

@Component({
	selector: 'app-edit-case-history',
	templateUrl: './edit-case-history.component.html',
	styleUrls: ['./edit-case-history.component.scss']
})
export class EditCaseHistoryComponent implements OnInit {

	private _lawsuiteId: number;
	private _instanceId: number;
	loading = false;
	error: string = '';
	history: HistoryEntry[] = [];

	@Input()
	set lawsuiteId(id: number) {
		this._lawsuiteId = id;
		this._instanceId = null;
		if (id) {
			this.load();
		} else {
			this.history = [];
		}
	}
	get lawsuiteId(): number {
		return this._lawsuiteId;
	}

	@Input()
	set instanceId(id: number) {
		this._instanceId = id;
		this._lawsuiteId = null;
		if (id) {
			this.load();
		} else {
			this.history = [];
		}
	}
	get instanceId(): number {
		return this._instanceId;
	}

	constructor(private caseService: CaseService) { }

	ngOnInit() {
		if (this._instanceId) {
			this.load();
		} else if (this._lawsuiteId) {
			this.load();
		}
	}

	load() {
		this.loading = true;
		this.error = '';
		const obs = this._instanceId
			? this.caseService.getInstanceHistory(this._instanceId)
			: this.caseService.getCaseHistory(this._lawsuiteId);
		obs.subscribe(
			data => {
				this.history = data || [];
				this.loading = false;
			},
			err => {
				this.error = (err && err.error && err.error.message) || 'Грешка при зареждане на историята.';
				this.loading = false;
			}
		);
	}

	fieldLabel(field: string): string {
		return FIELD_LABELS[field] || field;
	}

	actionLabel(action: string): string {
		switch (action) {
			case 'CREATED': return 'Създаване';
			case 'MODIFIED': return 'Промяна';
			case 'DELETED': return 'Изтриване';
			default: return action;
		}
	}

	actionClass(action: string): string {
		switch (action) {
			case 'CREATED': return 'action-created';
			case 'MODIFIED': return 'action-modified';
			case 'DELETED': return 'action-deleted';
			default: return '';
		}
	}

	formatDate(s: string): string {
		if (!s) return '';
		const d = new Date(s);
		if (isNaN(d.getTime())) return s;
		const pad = (n: number) => ('0' + n).slice(-2);
		return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear()
			+ ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
	}
}
